/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 *
 * The sport palettes live in src/theme/themes.ts (the single colour source
 * of truth since Vuetify Removal Plan Phase 1) — this plugin only adapts
 * them into Vuetify ThemeDefinitions. This whole file is deleted in Phase 8.
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Composables
import { createVuetify, type ThemeDefinition } from 'vuetify';

import { themes } from '@/theme';

const vuetifyThemes = Object.fromEntries(
  Object.entries(themes).map(([name, theme]) => [name, theme as ThemeDefinition])
);

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'squashTheme',
    themes: vuetifyThemes,
  },
});
